import { useEffect, useRef, useState } from "react";
import { Button, Paper, Stack, styled, TextField } from "@mui/material";
import { Form, useActionData, useRouteLoaderData } from "react-router-dom";

import useInfoSnackbar from "../../lib/bandung/hooks/useInfoSnackbar";
import FormHeader from "../ui/FormHeader";

const StyledStack = styled(Stack)`
  height: 100%;
  width: 80%;
  padding-top: 3em;
`;

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  width: clamp(440px, 100%, 600px);
  height: 100%;
  padding: 3em 0;
`;

const ContactForm = ({ formTitle, path }) => {
  const CHARACTER_LIMIT_REQ = 15;
  const CHARACTER_LIMIT_DES = 1500;
  const formRef = useRef();
  const snackbarInfo = useInfoSnackbar(3000);

  const loaderData = useRouteLoaderData(path);
  const userEntity = loaderData.userEntityRes?.data;

  const actionData = useActionData();

  const [formData, setFormData] = useState({
    request: "",
    longDescription: "",
  });

  useEffect(() => {
    if (actionData) {
      if (actionData.code === "SUCCESS") {
        snackbarInfo.alertSuccess(actionData.message);
        formRef.current.reset();
        setFormData({
          request: "",
          longDescription: "",
        });
      } else {
        snackbarInfo.alertError(actionData.message);
      }
    }
  }, [actionData]);

  const handleChange = (name) => (event) => {
    const { value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <StyledPaper>
      <FormHeader title={formTitle} />
      <StyledStack>
        <Form method="post" action={"/" + path} ref={formRef}>
          <input
            name="useSessionInfo"
            readOnly
            hidden
            value={(!!userEntity).toString()}
          />
          <Stack
            direction={"row"}
            justifyContent={"space-between"}
            spacing={2}
            mb={2}
          >
            <TextField
              type="text"
              id="firstName"
              name="firstName"
              label={"First Name"}
              fullWidth
              required={true}
              value={userEntity?.firstName}
              disabled={!!userEntity}
            />
            <TextField
              type="text"
              id="lastName"
              name="lastName"
              label={"Last Name"}
              fullWidth
              required={true}
              value={userEntity?.lastName}
              disabled={!!userEntity}
            />
          </Stack>
          <Stack
            direction={"column"}
            justifyContent={"space-between"}
            spacing={2}
            mb={2}
          >
            <TextField
              type="email"
              id="email"
              name="email"
              label={"Email Address"}
              fullWidth
              required={true}
              value={userEntity?.email}
              disabled={!!userEntity}
            />
            <TextField
              type="text"
              id="request"
              name="request"
              label={"Request"}
              fullWidth
              required={true}
              inputProps={{
                maxLength: CHARACTER_LIMIT_REQ,
              }}
              value={formData.request}
              helperText={`${formData.request.length}/${CHARACTER_LIMIT_REQ}`}
              onChange={handleChange("request")}
            />
            <TextField
              type="text"
              id="longDescription"
              name="longDescription"
              label={"What were you hoping to learn more about?"}
              fullWidth
              multiline
              rows={4}
              inputProps={{
                maxLength: CHARACTER_LIMIT_DES,
              }}
              value={formData.longDescription}
              helperText={`${formData.longDescription.length}/${CHARACTER_LIMIT_DES}`}
              onChange={handleChange("longDescription")}
            />
          </Stack>
          <Stack mt={2}>
            <Button
              type={"submit"}
              variant={"outlined"}
              sx={{
                color: "#1e3faf",
                borderRadius:  "9999px",
                borderColor: "#60a5fa",
                "&:hover": {
                  backgroundColor: "#dbeafe",
                },
              }}
            >
              Submit
            </Button>
          </Stack>
        </Form>
      </StyledStack>
    </StyledPaper>
  );
};

export default ContactForm;
